// main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import zhTW from './lang/zh-TW'
import zhCN from './lang/zh-CN'
import en from './lang/en'

Vue.use(ElementUI)
Vue.use(VueI18n)

Vue.config.productionTip = false
const i18n = new VueI18n({
  locale: 'zh-TW', // 預設語言繁體
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    en: en
  }
})
new Vue({
  router,
    i18n,
  render: h => h(App)
}).$mount('#app')

